import moment from "moment";

// *****
//open/close -> event 
//start/end -> inscription
// *****

//Differents STATUS on event or inscription spread in the App
export const STATUS = {
    DRAFT : "draft",
    COMING: "coming",
    PUBLISH : "ongoing",
    ONGOING: "ongoing",
    FULL_FREE: "full_free",
    SUBSCRIPTION: 'subscription',
    FULL: "full",
    FREE: "free",
    DONE : "done",
    PENDING : "pending",
    INCOMING: "incoming"
}

//helper to make the description shorter
export const description = (description, number) => description.replace(/&nbsp;/g, ' ').replace(/<(.|\n)*?>/g, '').substring(0, number) + (description.length > number ? '...' : '')

//helper to bind the status from the API with our APP (event or inscription)
export const is = (event, inscription = false) => {
    if ( event.status === "done" ) //|| (now.isAfter(start) && now.isAfter(end)) )
        return STATUS.DONE;

    if(inscription){
        if((event.subscribeNumber === 0)
            && (!moment(event.startAt).isValid() || !moment(event.endAt).isValid()) 
        )
          return STATUS.FULL_FREE;

        
        if(event.subscribeNumber !== 0 
            && event.subscribeNumber <= event.subscribedNumber)
            return STATUS.FULL;

        if(event.status === 'subscription')
            return STATUS.ONGOING;

        if(!moment(event.startAt).isValid() || !moment(event.endAt).isValid())
            return STATUS.FREE;

        if ( event.status === "oncoming"
            || moment(event.startAt).isAfter(moment()) )
            return STATUS.COMING;

        if ( event.status === "ongoing" 
            || moment(event.endAt).isBefore(moment()))  //status is not a good value.
            return STATUS.DONE;
    }

    if ( event.status === "pending" )
        return STATUS.COMING;

    if ( event.status === "draft" )
        return STATUS.DRAFT;
    
    if ( event.status === "ongoing" )
        return STATUS.ONGOING;
    
    if(event.status === 'subscription')
        return STATUS.SUBSCRIPTION;
    
    return STATUS.COMING;
}

//helper to display both event date in UI 
export const toStringDiffEvent = (e) => {
    const open = moment(e.openAt);
    const close = moment(e.closeAt);
    let format = open.isSame(close, 'year') ? 
        ( open.format('H:mm') === "0:00" && close.format('H:mm') === "0:00" ? 
            'D MMM' //all day
            : "D MMM [à] H:mm" ) //same year
        : 'lll'; //year display


    return open.isSame(close, 'day') ? 
        ( open.format('D MMM [de] H:mm') + ' ' + close.format('[à] H:mm') )// same day
        : ( open.format(format) + ' - ' + close.format(format) );
}

//helper to bind a status to a string and a color
// -> (usually with a Tag)
export const toTag = (status) => {

    return (
          status === STATUS.DONE   ?        { color : 'red',  text: "Terminé" }
        : status === STATUS.FULL   ?        { color : 'volcano',  text: "Complet" }
        : status === STATUS.FULL_FREE ?     { color : 'green',  text: "Entrée libre" }
        : status === STATUS.COMING ?        { color : 'blue',  text: "À venir" }
        : status === STATUS.FREE   ?        { color : 'green',  text: "Ouvert" }
        : status === STATUS.ONGOING ?       { color : 'orange',  text: "En cours" }
        : status === STATUS.DRAFT ?         { color : 'default',  text: "Brouillon" }
        : status === STATUS.SUBSCRIPTION ?  { color : 'cyan',  text: "Inscription en cours" }
        :                                   { color : 'default',  text: "NA" });
}

//make a copy of Event_Base
export const EVENT = () => JSON.parse(JSON.stringify(EVENT_BASE));
export const SETEVENT = (_event) => {
    if(!_event)
        return EVENT();

    let event = Object.assign(EVENT(), _event)
    event.eventCategory = event.eventCategory.map(c => c.category.id )
    event.noRegistration = event.subscribeNumber === 0 && !event.startAt && !event.endAt;
    event.noLocation = event.location === null || !event.location;

    return event;
} 

//EVENT BASE is an object of an event in API empty to fill it before to send
//there are some value that are not exist in the API but we remove then before to SAVE ( -> see format Event )
// the main reason is to save time and avoid extra props or state
export const EVENT_BASE = {
    "title": null,
    "description": null,
    "subscribeNumber": 0,
    "status": 1,
    "location": null,
    "startAt": null,
    "closeAt": null,
    "openAt": null,
    "endAt": null,
    "juryPoint": null,
    "validationRequired": false,
    "eventCategory": [],
    "images": [], // exist but is set in another url
    "noRegistration": true, // not exist
    "noLocation": true, // not exist
    "restrictedEvent": false,
    "restrictedRolesList" : null,
    "restrictedRolesChange" : false, // not exist
    "restrictedRoles": []
  }

//helper for date
export const MOMENT = {
    TIME: 'HH:mm',
    DATE: 'Do MMMM YYYY'
}

//helper to update an event before sending 
export const formatEvent = function(event, status){
    let _event = JSON.parse(JSON.stringify(event));
    _event.status = status;
    /*
        DATE MODIFICATION
    */
    if(_event.startAt)
        _event.startAt = moment(_event.startAt).format();
    if(_event.endAt)
        _event.endAt = moment(_event.endAt).format();
    if(_event.openAt)
        _event.openAt = moment(_event.openAt).format();
    if(_event.closeAt)
        _event.closeAt = moment(_event.closeAt).format();
    //Registration field
    //if there is NO registration -> no date and no validation
    if(_event.noRegistration) {
        _event.startAt = null;
        _event.endAt = null;
        _event.subscribeNumber = 0;
        _event.validationRequired = false;
    }
    //Location field
    //if there is NO location -> remove location
    if(_event.noLocation) {
        _event.location = null;
    }
    //prices should not be here for the API
    //just in case
    if(_event.prices){
        delete _event.prices;
    }
    //if the restrictedEvent is false is mean no restriction at ALL
    if(!_event.restrictedEvent){
        _event.restrictedRolesList = []
    }
    //if a change is done and no restriction is filled then we disactivated the access.
    if(_event.restrictedRolesChange && ( !_event.restrictedRolesList || _event.restrictedRolesList.length === 0 ) ){
        _event.restrictedEvent = false;
    }

    // delete useless information
    delete _event.restrictedRolesChange
    delete _event.noRegistration;
    delete _event.noLocation;
    delete _event.images;

    return _event;
}

//Role in the DB
export const roleOptions = (_ROLE) => [
    {
        id: _ROLE.FOREIGNER,
        name:  "Extérieur à Ynov",
        color: "geekblue",
    },
    {
        id: _ROLE.STUDENT, 
        name:  "Etudiant Ynov", 
        color: "cyan",
    },
    {
        id: _ROLE.MODERATOR,
        name:  "Modérateur",
        color: "purple",
    },
    {
        id: _ROLE.STAFF,
        name:  "Staff",
        color: "volcano",
    },
    {
        id: _ROLE.ADMIN,
        name:  "Admin",
        color: "magenta",
    },
]

//helper for restricted
export const isRestricted = (event) => (event.restrictedRoles && event.restrictedRoles.length > 0);

export const ROLE = {
    MODERATOR : "Moderator",
    STUDENT: "Student",
    STAFF: "Staff",
    FOREIGNER: "Foreigner",
    ADMIN: "Admin"
}

export const restrictedLevel = (event) => {
    if(!isRestricted(event)) return { role : 0, title: "", class: "", name: "Accessible à tous" }

    const isOnlyOne = event.restrictedRoles.length === 1;
    const roles =  event.restrictedRoles.map(r => r.role.name);


    if((isOnlyOne && roles.includes(ROLE.STUDENT)) || (roles.includes(ROLE.STUDENT) && !roles.includes(ROLE.FOREIGNER)))
        return { role : ROLE.STUDENT, class: "ynov", title: "Exclusivité", name: "Accessible uniquement aux étudiants Ynov" }
    if((isOnlyOne && roles.includes(ROLE.FOREIGNER)) || (roles.includes(ROLE.FOREIGNER) && !roles.includes(ROLE.STUDENT)))
        return { role : ROLE.FOREIGNER, class: "foreigners", title: "Découverte", name: "Accessible uniquement aux personnes extérieures" }
     
    return { role : ROLE.MODERATOR, class: "moderators", title: "Staff", name: "Accès réservé" }
}




// WEBPACK FOOTER //
// ./src/features/admin/events/Constants.js